import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Form, { FormControl, FormRow, FormExtra } from 'rebook/apps/base/components/form/Form';
import Button from 'rebook/apps/base/components/Button';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import AuthFormSocialAuth from 'rebook/mybook/App/AuthForm/AuthFormSocialAuth';
import { URLS } from 'rebook/apps/base/constants';


class AuthLoginForm extends React.Component {
  onBeforeSubmit() {
    if (this.props.type === 'login' && this.props.GALabel) {
      ga('send', 'event', 'LogIn', 'PushButton', this.props.GALabel);
    }
  }

  onSuccess() {
    if (this.props.type === 'login' && this.props.GALabel) {
      ga('send', 'event', 'LogIn', 'LogIn', this.props.GALabel);
    }
    if (this.props.onSuccess) {
      this.props.onSuccess();
    }
  }

  handleForgetPassword() {
    if (this.props.type === 'login' && this.props.GALabel) {
      ga('send', 'event', 'Login', 'ForgetPass');
    }
    this.props.AuthFormActions.hideForm();
  }

  render() {
    const {
      onInit, onChange, onSubmit, onError, submitButtonText, form, isInProgress,
      errorList, handleChangeFormType, displaySocialAuth,
    } = this.props;

    return (
      <div className="jest-auth-form">
        <Form
          action="/api/auth/"
          method="post"
          onBeforeSubmit={this.onBeforeSubmit.bind(this)}
          onSubmit={onSubmit}
          onSuccess={(data) => this.onSuccess(data)}
          onError={onError}>
          <FormRow extraClassName="jest-auth-email">
            <FormTextInput
              name="email"
              isDisabled={isInProgress}
              isRequired
              isRequiredError="Введите почту или телефон"
              onInit={onInit}
              onChange={onChange}
              errorList={errorList.email}
              value={form.email && form.email.value}
              label="Почта или телефон" />
          </FormRow>
          <FormRow extraClassName="jest-auth-password">
            <FormTextInput
              name="password"
              type="password"
              isDisabled={isInProgress}
              isRequired
              isRequiredError="Введите пароль"
              onInit={onInit}
              onChange={onChange}
              errorList={errorList.password}
              label="Пароль" />
          </FormRow>
          <FormControl>
            <Button isInProgress={isInProgress}>
              {submitButtonText}
            </Button>
          </FormControl>
        </Form>
        {displaySocialAuth && (
          <FormExtra>
            <AuthFormSocialAuth />
          </FormExtra>
        )}
        <FormExtra>
          <Button
            theme="secondary"
            size="small"
            url={URLS.accountResetPassword}
            handleClick={this.handleForgetPassword.bind(this)}>
            Забыл пароль
          </Button>
        </FormExtra>
        <FormExtra>
          <Button
            extraClassName="jest-registration-button"
            size="small"
            theme="secondary"
            handleClick={()=>{
              ga('send', 'event', 'Registration', 'CallForRegistration');
              handleChangeFormType();
            }}>
            Зарегистрироваться
          </Button>
        </FormExtra>
      </div>
    );
  };
}

AuthLoginForm.propTypes = {
  submitButtonText: PropTypes.string,
};

AuthLoginForm.defaultProps = {
  submitButtonText: 'Войти',
};

function mapDispatchToProps(dispatch) {
  return {
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(AuthLoginForm);
